import { connect } from "react-redux";

import CrematoryOverviewContainer from "./CrematoryOverviewContainer";
import roleTypes from "../../constants/roles";

const mapStateToProps = (state) => {
    const isAdmin = state.user.profile.roles.includes(roleTypes.admin);

    let showOrganizationMusicStats = false;
    let musicStatsOrganizationId = null;

    if (
        state.user.profile?.organizationId &&
        state.user.profile?.showOrganizationMusicStats
    ) {
        showOrganizationMusicStats =
            state.user.profile.showOrganizationMusicStats;
        musicStatsOrganizationId = state.user.profile.organizationId;
    }

    return {
        isAdmin,
        showOrganizationMusicStats,
        musicStatsOrganizationId,
    };
};

export default connect(mapStateToProps)(CrematoryOverviewContainer);
